import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { EMPLOYEE_ATTENDANCE_LIST } from 'src/constants/EndpointUrls';
import { formatDate, formatYearMonth } from 'src/utils/Date';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
// Reducer
import {
  setEmployeeAttendancesQueries,
  setEmployeeAttendancesListExtra
} from 'src/reducers/employees/employeeAttendances';
// Form
import EmployeeAttendanceDownloadCsvForm from './components/EmployeeAttendanceDownloadCsvForm';
import DownloadColumnDetail from './components/DownloadColumnDetail';
import AttendanceSyncWithJbcResult from './components/AttendanceSyncWithJbcResult';
import ImportAttendanceCsvJobStatus from './components/ImportAttendanceCsvJobStatus';
import styles from './EmployeeAttendanceDownloadCsvPage.scss';

const ConnectedDownloadCsv = ({ startDate, endDate, attendanceStartDate, attendanceEndDate, paymentDate }) => {
  const [t, i18n] = useTranslation();
  return (
    <div>
      <div className="l-wrap-xs l-contents-wrap">
        <BreadCrumb>
          <BreadCrumb.Item label={t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.attendance_list')} path={EMPLOYEE_ATTENDANCE_LIST} />
          <BreadCrumb.Item label={t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.upload_csv_of_attendance_items')} />
        </BreadCrumb>
      </div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.update_attendance_information')}</h1>
      </div>
      <AttendanceSyncWithJbcResult />
      <ImportAttendanceCsvJobStatus />
      <div className="l-wrap-xs">
        <p>
          {t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.update_all_numbers_under_attendance_items_used_in_payroll_in_the_following_month_by_CSV_file')}<br />{t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.pay_attention_to_attendance_item_name_when_importing_attendance_data_from_other_software')}
        </p>
        <div className={styles.target}>
          {formatYearMonth(paymentDate)}
          <div className={styles.period}>
            <span>
              {t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.subjected_period')}：{formatDate(attendanceStartDate)}〜{formatDate(attendanceEndDate)}
            </span>
            <span>{t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.payment_date')}：{formatDate(paymentDate)}</span>
          </div>
        </div>
      </div>
      <EmployeeAttendanceDownloadCsvForm
        jobInfo={`${t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.subjected_period')}：${formatDate(startDate)}〜${formatDate(endDate)} ${t('features.EmployeeAttendances.EmployeeAttendanceDownloadCsvPage.payment_date')}：${formatDate(paymentDate)}`}
      />
      <div className={styles.detail}>
        <DownloadColumnDetail />
      </div>
    </div>
  );
};

const EmployeeAttendanceDownloadCsvPage = ({ dispatch, values }) => {
  dispatch(setEmployeeAttendancesQueries(values.queries));
  dispatch(setEmployeeAttendancesListExtra({ importJobs: values.importJobs }));

  return <ConnectedDownloadCsv {...values.targetPeriod} />;
};
export default connect()(EmployeeAttendanceDownloadCsvPage);
